import { privateRequest } from "../axios";

const ENDPOINTS = {
  USER: "/user",
  USER_ID: (id) => `/user/${id}`,
  USER_EXPORT: '/user/export',
  APP_SETTING : '/app-setting',
  APP_SETTING_ID : (id) => `/app-setting/${id}`,
};

const getUsers = async (params) => {
  const response = await privateRequest.get(ENDPOINTS.USER, { params });
  return response?.data;
};

const getUserById = async (id) => {
  const response = await privateRequest.get(ENDPOINTS.USER_ID(id));
  return response?.data;
};

const addUser = async (data) => {
  const response = await privateRequest.post(ENDPOINTS.USER, data);
  return response?.data;
};

const updateUser = async (id, data) => {
  const response = await privateRequest.put(ENDPOINTS.USER_ID(id), data);
  return response?.data;
};

const deleteUser = async (id) => {
  const response = await privateRequest.delete(ENDPOINTS.USER_ID(id));
  return response?.data;
};

// const getUserExport = async (id) => {
//   const response = await privateRequest.get(ENDPOINTS.USER_EXPORT(id));
//   return response?.data;
// };

// const getUserExport = async (params) => {
//   const response = await privateRequest.get(ENDPOINTS.USER_EXPORT, {
//     params, // will be undefined or an object like { roleId: 1 }
//   });
//   return response?.data;
// };


const getUserExport = async (query = "") => {
  const url = `${ENDPOINTS.USER_EXPORT}${query}`;
  const response = await privateRequest.get(url);
  return response?.data;
};

const getAppSetting = async (params) => {
  const response = await privateRequest.get(ENDPOINTS.APP_SETTING, { params });
  console.log(response);
  
  return response?.data;
};


const addAppSetting = async (data) => {
  const response = await privateRequest.post(ENDPOINTS.APP_SETTING, data);
  return response?.data;
};

const updateAppSetting = async (id, data) => {
  const response = await privateRequest.put(ENDPOINTS.APP_SETTING_ID(id), data);
  return response?.data;
};

const deleteAppSetting = async (id) => {
  const response = await privateRequest.delete(ENDPOINTS.APP_SETTING_ID(id));
  return response?.data;
};


const UserService = {
  getUsers,
  getUserById,
  addUser,
  updateUser,
  deleteUser,
  getUserExport,
  getAppSetting,
  addAppSetting,
  updateAppSetting,
  deleteAppSetting
};

export default UserService;
